<script>
  export default {
    props: {
      src: {
        type: String,
        required: false,
        default: "",
      },

      customFullback: {
        type: String,
        required: false,
        default: "",
      },

      alt: {
        type: String,
        required: false,
        default: "",
      },

      width: {
        type: [Number, String],
        default: "auto",
      },
    },
    data() {
      return {
        imageSrc: "",
      };
    },
    watch: {
      src: {
        immediate: true,
        handler(src) {
          const fallback = this.customFullback ? this.customFullback : require("@/assets/images/shared/any-missing-icon.svg")
          this.isImageSrcValid(src)
            .then((isValid) => {
              this.imageSrc = isValid
                ? src
                : fallback;
            });
        },
      },
    },
    methods: {
      isImageSrcValid(src) {
        return new Promise((resolve) => {
          const imageSrc = new Image();
          imageSrc.src = src;
          imageSrc.onload = () => resolve(true);
          imageSrc.onerror = () => resolve(false);
        });
      },
    },
  }
</script>

<template>
  <img
    :alt="alt"
    :height="width"
    :src="imageSrc"
    :width="width"
  >
</template>
